import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import client from "../../services/client";
import { ENDPOINTS } from "../../config";

// Thunk to update vendor status
export const updateVendorStatus = createAsyncThunk(
  "vendor/updateStatus",
  async ({ vendorId, isActive }, thunkAPI) => {
    try {
      const response = await client.put(ENDPOINTS.vendorStatusUpdate, null, {
        params: { isActive, vendorId },
      });
      return { vendorId, isActive, updatedStatus: response.data };
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

// Initial state
const initialState = {
  status: "idle", // idle / loading / succeeded / failed
  error: null,
};

// Vendor status slice
const vendorStatusSlice = createSlice({
  name: "vendorStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateVendorStatus.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateVendorStatus.fulfilled, (state, action) => {
        console.log("action.payload", action.payload);
        console.log("stateeeee", state);
        // const { vendorId, isActive } = action.payload;
        state.status = "succeeded";
        // state.vendors = state.vendors.map((vendor) =>
        //   vendor.id === vendorId
        //     ? { ...vendor, status: isActive ? "Active" : "Inactive" }
        //     : vendor
        // );
      })
      .addCase(updateVendorStatus.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload?.message || "Something went wrong";
      });
  },
});

export default vendorStatusSlice.reducer;
